import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ItemUploadDataJSON, S3UploadJSON } from '../s3-upload.interface';
import { S3UploadService } from '../s3-upload.service';
import { HttpEvent, HttpEventType, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';

@Component({
  selector: 'zf-s3-upload-image',
  templateUrl: './s3-upload-image.component.html',
  styleUrls: ['./s3-upload-image.component.scss'],
})
export class S3UploadImageComponent implements OnInit {
  @Input() urlPresigned!: string;
  @Input() bucket!: string;
  @Input() folder!: string;
  @Input() client!: string;
  @Input() imageZoom!: boolean;
  @Input() sizeLimitMB!: number;
  @Input() removeAfterUploader!: boolean;

  @Output() urlUploaded: EventEmitter<any> = new EventEmitter<any>();
  @Output() urlUploadedError: EventEmitter<any> = new EventEmitter<any>();

  private _url: any;
  @Input()
  set url(value: any) {
    this._url = Object.assign('', value);

    if (this.version === '3') {
      this.versionThreeUploaded = true;
      setTimeout(() => {
        this.imageUrl = value;
      });
    }
  }

  get url(): any {
    return this._url;
  }

  private _version!: string;
  @Input()
  set version(value: string) {
    this._version = value;
  }

  get version(): string {
    return this._version;
  }

  private _uploadNew!: File;
  @Input()
  set uploadNew(value: File) {
    this._uploadNew = value ? value : ({} as File);
    if (value) {
      this.externalContentUpload(value);
    }
  }

  files: any[] = [];
  selectedFiles!: FileList;
  isUploaded: boolean = false;
  progress: number = 0;
  message: any = null;
  errorMsg!: string;
  imageUrl: string =
    'https://s3.amazonaws.com/stage.mango.template/default-image.jpg';
  versionThreeUploaded: boolean = false;
  fileUpload!: File;

  token!: number;

  constructor(private uploadService: S3UploadService) {}

  ngOnInit() {
    this.token = Math.floor(new Date().getTime() + Math.random());

    if (this.version !== 'none') {
      this.checkImageExist(this.url).then(
        (result) => {
          this.imageUrl = this.url;
          if (this.version === '3') {
            this.versionThreeUploaded = true;
          }
        },
        (err) => {
          this.imageUrl =
            'https://s3.amazonaws.com/stage.mango.template/default-image.jpg';
        }
      );
    }
  }

  upload() {
    this.errorMsg = '';
    this.isUploaded = true;
    const file = this.fileUpload ? this.fileUpload : this.selectedFiles.item(0);

    if (!file) {
      this.isUploaded = false;
    }

    const type = file?.type || '';
    const validImageTypes = [
      'image/gif',
      'image/jpeg',
      'image/jpg',
      'image/png',
      'image/svg+xml',
    ];
    if (validImageTypes.indexOf(type) === -1) {
      this.isUploaded = false;
      this.urlUploadedError.emit({
        status: 'error',
        message: 'The uploaded file is not a valid image',
      });
      this.errorMsg = 'The uploaded file is not a valid image';
    } else {
      const data: S3UploadJSON = {
        urlPresigned: this.urlPresigned,
        bucket: this.bucket,
        folder: this.folder,
        client: this.client,
      };

      const token = Math.floor(Math.random() * 100000000).toString();

      // console.log('File 1: ', file)

      const type = file?.type === 'image/svg+xml' ? 'svg' : file?.type;
      const imageFile = new File([file as File], file?.name || '', {
        type: type,
      });

      this.uploadService.get(imageFile, data, token).subscribe(
        (result) => {
          this.uploadService.put(result, imageFile).subscribe(
            (event) => {
              this.isUploaded = false;
              const url = this.uploadService.process(
                imageFile,
                data,
                token
              ).urlDownload;

              if (event.type === HttpEventType.UploadProgress) {
                const percentDone = Math.round(
                  (100 * event.loaded) / event.total
                );
                this.progress = percentDone;
                // console.log(`File is ${percentDone}% uploaded.`)
              } else if (event instanceof HttpResponse) {
                // console.log('File is completely uploaded!')
                this.checkImageExist(url).then(
                  (validUrl) => {
                    this.imageUrl = url;
                    this.urlUploaded.emit({
                      status: 'success',
                      url: url,
                      isFixed: this.fileUpload ? true : false,
                    });
                    this.fileUpload = {} as File;
                  },
                  (err) => {
                    this.errorMsg = 'Error: Image could not be uploaded.';
                    this.imageUrl =
                      'https://s3.amazonaws.com/stage.mango.template/default-image.jpg';
                  }
                );
              }
            },
            (err) => {
              console.log(err);
              if (err.status === 403) {
                this.errorMsg = 'Error: Access Denied. Request has expired.';
              }
              this.isUploaded = false;
            }
          );
        },
        (err) => {
          console.log(err);
          this.errorMsg = err.message;
          this.isUploaded = false;
        }
      );

      // this.resizeImage({
      //   file: file,
      //   maxSize: 800
      // }).then((resizedImage: any) => {
      //   const imageFile = new File([new Blob(resizedImage)], file.name, {type: file.type})

      //   this.uploadService.get(imageFile, data, token)
      //     .subscribe(result => {
      //       this.uploadService.put(result, imageFile)
      //         .subscribe(() => {
      //           this.isUploaded = false
      //           const url = this.uploadService.process(imageFile, data, token).urlDownload

      //           this.checkImageExist(url)
      //             .then(validUrl => {
      //               this.imageUrl = url
      //               this.urlUploaded.emit({
      //                 'status': 'success',
      //                 'url': url,
      //                 'isFixed': this.fileUpload ? true : false
      //               })
      //               this.fileUpload = null
      //             }, err => {
      //               this.errorMsg = 'Error: Image could not be uploaded.'
      //               this.imageUrl = 'https://s3.amazonaws.com/stage.mango.template/default-image.jpg'
      //             })
      //         }, err => {
      //           console.log(err)
      //           if (err.status === 403) {
      //             this.errorMsg = 'Error: Access Denied. Request has expired.'
      //           }
      //           this.isUploaded = false
      //         })
      //     }, err => {
      //       console.log(err)
      //       this.errorMsg = err.message
      //       this.isUploaded = false
      //     })
      // }).catch(function (err) {
      //   console.log(err)
      //   this.errorMsg = 'Error: reducing images size'
      //   this.isUploaded = false
      // })
    }
  }

  externalContentUpload(fileUpload: File) {
    this.fileUpload = fileUpload;
    this.upload();
  }

  selectFile(event: any) {
    this.selectedFiles = event.target.files;
    this.upload();
  }

  selectFileMultiples(event: any) {
    const files = event.target.files;
    for (let i = 0; i < files.length; i++) {
      const item = files[i];
      const type = item.type;
      const validImageTypes = [
        'image/gif',
        'image/jpeg',
        'image/jpg',
        'image/png',
        'image/svg+xml',
      ];
      if (validImageTypes.indexOf(type) !== -1) {
        this.files.unshift({
          token: Math.floor(Math.random() * 100000000).toString(),
          file: item,
          urlPresigned: this.urlPresigned,
          bucket: this.bucket,
          folder: this.folder,
          client: this.client,
          sizeLimitMB: this.sizeLimitMB,
        } as ItemUploadDataJSON);
      }
    }
  }

  onMultipleUploaded(event: { token: any }) {
    if (!!this.removeAfterUploader) {
      for (let i = 0; i < this.files.length; i++) {
        const item = this.files[i];
        if (item.token === event.token) {
          this.files.splice(i, 1);
          break;
        }
      }
    }

    this.urlUploaded.emit(event);
  }

  onMultipleUploadedVersionThree(event: { token: any; url: string }) {
    if (!!this.removeAfterUploader) {
      for (let i = 0; i < this.files.length; i++) {
        const item = this.files[i];
        if (item.token === event.token) {
          this.files.splice(i, 1);
          break;
        }
      }
    }

    this.imageUrl = event.url;
    this.versionThreeUploaded = true;
    this.files = [];

    this.urlUploaded.emit(event);
  }

  private handleError(err: any) {
    return Observable.create(err);
  }

  private showProgress(message: number) {
    // console.log('message: ', message)
    // console.log('message typeof: ', typeof message)
    if (typeof message === 'number') {
      this.progress = message;
    }
    // else {
    //   this.message = message
    //   setTimeout(() => {
    //     this.message = null
    //   }, 2000)
    // }
  }

  private getEventMessage(event: HttpEvent<any>, file: File) {
    switch (event.type) {
      case HttpEventType.Sent:
        return `Uploading file "${file.name}" of size ${file.size}.`;

      case HttpEventType.UploadProgress:
        // Compute and show the % done:
        const percentDone = Math.round(
          (100 * event.loaded) / (event.total || 1)
        );
        return percentDone;

      case HttpEventType.Response:
        return `File "${file.name}" was completely uploaded!`;

      default:
        return `File "${file.name}" surprising upload event: ${event.type}.`;
    }
  }

  // https://stackoverflow.com/questions/51239965/check-if-image-exists-without-getting-404-error-adwords-fails
  checkImageExist(imageUrl: string) {
    return new Promise<void>((resolve, reject) => {
      const imageData = new Image();

      imageData.onload = () => {
        resolve();
      };

      imageData.onerror = () => {
        reject();
      };

      imageData.src = imageUrl;
    });
  }

  private resizeImage(settings: IResizeImageOptions) {
    const file = settings.file;
    const maxSize = settings.maxSize;
    const reader = new FileReader();
    const image = new Image();
    const canvas = document.createElement('canvas');
    const dataURItoBlob = (dataURI: string) => {
      const bytes =
        dataURI.split(',')[0].indexOf('base64') >= 0
          ? atob(dataURI.split(',')[1])
          : unescape(dataURI.split(',')[1]);
      const mime = dataURI.split(',')[0].split(':')[1].split(';')[0];
      const max = bytes.length;
      const ia = new Uint8Array(max);
      for (var i = 0; i < max; i++) {
        ia[i] = bytes.charCodeAt(i);
      }
      return new Blob([ia], { type: mime });
    };
    const resize = () => {
      let width = image.width;
      let height = image.height;

      if (width > height) {
        if (width > maxSize) {
          height *= maxSize / width;
          width = maxSize;
        }
      } else {
        if (height > maxSize) {
          width *= maxSize / height;
          height = maxSize;
        }
      }

      canvas.width = width;
      canvas.height = height;
      if (canvas.getContext('2d')) {
        const canvas2 = canvas.getContext('2d') as CanvasRenderingContext2D;
        canvas2.drawImage(image, 0, 0, width, height);
      }
      const dataUrl = canvas.toDataURL('image/jpeg');
      return dataURItoBlob(dataUrl);
    };

    return new Promise((ok, no) => {
      if (!file.type.match(/image.*/)) {
        no(new Error('Not an image'));
        return;
      }

      reader.onload = (readerEvent: any) => {
        image.onload = () => ok(resize());
        image.src = readerEvent.target.result;
      };
      reader.readAsDataURL(file);
    });
  }
}

interface IResizeImageOptions {
  maxSize: number;
  file: File;
}
